import React, { useState ,useEffect} from "react";
import {
  Row,
  Col,
  Space,
  Modal,
  Input,
  DatePicker,
  Collapse,
  Button,
  message,
  Form,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import EditIcon from "../../../../../ui/EditIcon";
import dayjs from "dayjs";
import { updatePatientExerciseAPI ,deleteExerciseAPI } from "../../../../../../services/outpatient.services";
import { useLocation } from "react-router-dom";
import {
  EXERCISE_NAME_TYPE_PATTERN,
  getExerciseNameValidationError,
} from "../OpExercise/exerciseFieldValidation";

const { Panel } = Collapse;

const PrescribedExercise = ({ prescribedData, setPrescribedData }) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editValues, setEditValues] = useState(null);
  const [openKeys, setOpenKeys] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  const exercises = Array.isArray(prescribedData) ? prescribedData : [];
  const validateEditExercise = (exercise) => {
  const nameErr = getExerciseNameValidationError(exercise.name);
  if (nameErr) {
    message.error(nameErr);
    return false;
  }

  const typeVal = exercise.type || exercise.exercise_type;
  if (
    !(exercise.type || exercise.exercise_type) ||
    !EXERCISE_NAME_TYPE_PATTERN.test(String(typeVal))
  ) {
    message.error(
      "Enter a valid Exercise type (letters, numbers, and .,'-_ only)"
    );
    return false;
  }

  if (
    exercise.frequency === undefined ||
    exercise.frequency === null ||
    exercise.frequency === ""
  ) {
    message.error(`Frequency is required for ${exercise.name}`);
    return false;
  }
  if (
    exercise.intensity === undefined ||
    exercise.intensity === null ||
    exercise.intensity === ""
  ) {
    message.error(`Intensity is required for ${exercise.name}`);
    return false;
  }
  if (!exercise.duration || isNaN(exercise.duration)) {
    message.error(`No. of days is required for ${exercise.name}`);
    return false;
  }
  if (!exercise.startDate) {
    message.error(`Start date is required for ${exercise.name}`);
    return false;
  }
  return true;
};
useEffect(() => {
  setOpenKeys(exercises.map(item => item.localId));
}, [exercises]);

  const handleDelete = async (id) => {
  try {
    await deleteExerciseAPI(id);
    setPrescribedData((prev) => prev.filter((item) => item.localId !== id));

    message.success("Exercise deleted successfully!");
  } catch (err) {
    console.error("Failed to delete exercise:", err);
    message.error("Failed to delete exercise");
  }
};

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
  const handleEdit = (item) => {
    setEditValues({ ...item });
    setEditModalVisible(true);
  };

  const handleSave = async () => {
  if (!validateEditExercise(editValues)) return;

  try {
    const payload = {
      name: editValues.name,
      exercise_type: editValues.type || editValues.exercise_type,
      frequency: Number(editValues.frequency),
      intensity: Number(editValues.intensity),
      duration: parseInt(editValues.duration),
      start_date: dayjs(editValues.startDate).toISOString(),
      time_slot: editValues.timeSlot || "12:00",
      file: editValues.s3Path
        ? [{ path: editValues.s3Path.path, type: editValues.s3Path.type }]
        : [],
    };

    await updatePatientExerciseAPI(editValues.localId, payload);
    setPrescribedData((prev) =>
      prev.map((item) =>
        item.localId === editValues.localId ? { ...item, ...editValues } : item
      )
    );

    setEditModalVisible(false);
    setEditValues(null);
    message.success("Exercise updated successfully!");
  } catch (err) {
    console.error("Failed to update exercise:", err);
    message.error("Failed to update exercise");
  }
};



  const getEmbedUrl = (url) => {
    try {
      if (url.includes("youtube.com/watch")) {
        const videoId = new URLSearchParams(new URL(url).search).get("v");
        return `https://www.youtube.com/embed/${videoId}`;
      }
      if (url.includes("youtu.be/")) {
        const videoId = url.split("youtu.be/")[1];
        return `https://www.youtube.com/embed/${videoId}`;
      }
      return url;
    } catch {
      return url;
    }
  };

  const isVideoFile = (url) =>
    /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  const renderVideo = (item) => {
    if (item.link) {
      if (item.link.includes("youtube.com") || item.link.includes("youtu.be")) {
        return (
          <iframe
            width="100%"
            height="200"
            src={getEmbedUrl(item.link)}
            title="Exercise Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: 8, marginBottom: 8 }}
          />
        );
      } else if (isVideoFile(item.link)) {
        return (
          <video
            width="100%"
            height="200"
            controls
            style={{ borderRadius: 8, marginBottom: 8 }}
            src={item.link}
          />
        );
      }
    } else if (item.s3Path) {
      const url = item.s3Path.url || item.s3Path.path;
      if (isVideoFile(url)) {
        return (
          <video
            width="100%"
            height="200"
            controls
            style={{ borderRadius: 8, marginBottom: 8 }}
            src={url}
          />
        );
      }
    } else if (item.videoFile) {
      const fileUrl = URL.createObjectURL(item.videoFile.originFileObj || item.videoFile);
      return (
        <video
          width="100%"
          height="200"
          controls
          style={{ borderRadius: 8, marginBottom: 8 }}
          src={fileUrl}
        />
      );
    }

    return <p style={{ color: "#999", marginBottom: 8 }}>No video attached</p>;
  };

  return (
    <>
      {prescribedData.length === 0 && (
        <div style={{ textAlign: "center", color: "#999" }}>
          No prescribed exercises yet.
        </div>
      )}

      <Collapse
        className="prescribed-collapse"
        activeKey={openKeys}
        onChange={(keys) => setOpenKeys(keys)}
      >

        {exercises.map((item) => (
          <Panel header={item.name || "New Exercise"} key={item.localId}>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                {renderVideo(item)}

                <p>
                  <strong>Exercise Name :</strong> {item.name}
                </p>
                <p>
                  <strong>Exercise Type :</strong> {item.type || item.exercise_type || "N/A"}
                </p>
                <p>
                  <strong>Frequency :</strong> {item.frequency}
                </p>
                <p>
                  <strong>Intensity :</strong> {item.intensity}
                </p>
                <p>
                  <strong>Start Date :</strong>{" "}
                  {item.startDate ? dayjs(item.startDate).format("DD/MM/YYYY") : "N/A"}
                </p>
                <p>
                  <strong>No. of Days :</strong> {item.duration}
                </p>
              </Col>

              <Col span={24}>
                <Space>
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    onClick={() => handleDelete(item.localId)}
                  >
                    Delete
                  </Button>
                  <Button
                    type="primary"
                    icon={<EditIcon />}
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </Button>
                </Space>
              </Col>
            </Row>
          </Panel>
        ))}
      </Collapse>

      <Modal
  title={`Edit Exercise - ${editValues?.name || ""}`}
  open={editModalVisible}
  onCancel={() => setEditModalVisible(false)}
  onOk={handleSave}
  okText="Update"
  destroyOnClose
  centered={isMobile}
  wrapClassName={isMobile ? "op-compact-modal-wrap" : undefined}
  width={isMobile ? undefined : 800}
  bodyStyle={isMobile ? { maxHeight: "60vh", overflowY: "auto", padding: 12 } : {}}
>

        {editValues && (
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={24} md={12}>
              <label>Exercise Name</label>
              <Input
                value={editValues.name}
                onChange={(e) =>
                  setEditValues({ ...editValues, name: e.target.value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12}>
              <label>Frequency</label>
              <Input
                type="number"
                value={editValues.frequency}
                onChange={(e) =>
                  setEditValues({ ...editValues, frequency: e.target.value })
                }
              />
            </Col>

            <Col xs={24} sm={24} md={12}>
              <label>Intensity</label>
              <Input
                type="number"
                value={editValues.intensity}
                onChange={(e) =>
                  setEditValues({ ...editValues, intensity: e.target.value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12}>
              <label>No. of Days</label>
              <Input
                type="number"
                value={editValues.duration}
                onChange={(e) =>
                  setEditValues({ ...editValues, duration: e.target.value })
                }
              />
            </Col>

            <Col xs={24} sm={24} md={12}>
              <label>Start Date</label>
              <DatePicker
                style={{ width: "100%" }}
                value={editValues.startDate ? dayjs(editValues.startDate) : null}
                onChange={(date) =>
                  setEditValues({
                    ...editValues,
                    startDate: date ? date.toISOString() : null,
                  })
                }
              />
            </Col>
            {(editValues.link || editValues.s3Path || editValues.videoFile) && (
              <Col span={24} style={{ marginTop: 20 }}>
                <label>Exercise Video Preview</label>
                <div
                  style={{
                    marginTop: 8,
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: 10,
                    textAlign: "center",
                  }}
                >
                  {editValues.link &&
                  (isVideoFile(editValues.link) ||
                    editValues.link.includes("youtube.com") ||
                    editValues.link.includes("youtu.be")) ? (
                    editValues.link.includes("youtube.com") ||
                    editValues.link.includes("youtu.be") ? (
                      <iframe
                        width="100%"
                        height="300"
                        src={getEmbedUrl(editValues.link)}
                        title="Exercise Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    ) : (
                      <video
                        width="100%"
                        height="300"
                        controls
                        src={editValues.link}
                      />
                    )
                  ) : editValues.s3Path ? (
                    <video
                      width="100%"
                      height="300"
                      controls
                      src={editValues.s3Path.url || editValues.s3Path.path}
                    />
                  ) : editValues.videoFile ? (
                    <video
                      width="100%"
                      height="300"
                      controls
                      src={URL.createObjectURL(
                        editValues.videoFile.originFileObj || editValues.videoFile
                      )}
                    />
                  ) : (
                    <p>No video available</p>
                  )}
                </div>
              </Col>
            )}
          </Row>
        )}
      </Modal>
    </>
  );
};

export default PrescribedExercise;
